export default {
  open: false,

  stuck: false,

  scrollDir: null,

  init() {
    this.setHeaderHeight();
    this.watchScrollDirection();
  },

  watchScrollDirection() {
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
      let curScrollY = window.scrollY;

      if (lastScrollY < curScrollY) {
        this.scrollDir = 'down';
      } else if (lastScrollY > curScrollY) {
        this.scrollDir = 'up';
      } else {
        this.scrollDir = null;
      }

      lastScrollY = curScrollY;
    });
  },

  toggleNav() {
    this.open = !this.open;
  },

  setHeaderHeight() {
    document.body.style.setProperty(
      '--header-height',
      getComputedStyle(document.querySelector('#site-header')).height
    );
  }
};
